import React, { useEffect, useState } from "react";

// import Slide from "@material-ui/core/Slide";
import AuthentificationService from "../services/authentification";
import { Alert, Snackbar } from "@mui/material";


export default function Logout({ setLogoutDisplay }) {
  // const navigate = useNavigate();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    setOpen(true);
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleClose = () => {
    AuthentificationService.logout().then((response) => {
      console.log(response);
      if (response.data["success"]) {
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem("accessIsDenied", "notConnected");
        window.location.href = "/login";
      }
      if (Object.keys(response.data) === "failed") {
        setOpenErrorAlert(true);
      }
    });

    setOpen(false);
    setLogoutDisplay(false);
  };

  const handleCloseConfirm = () => {
    setLogoutDisplay(false);
    setOpen(false);
  };

  return (
    <>
      <div class="modal fade" id="modal-secondary">
        <div class="modal-dialog">
          <div class="modal-content bg-black">
            <div class="modal-header">
              <h4 class="modal-title">Voulez-vous vraiment se déconnecter</h4>
            </div>

            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={handleCloseConfirm}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button type="button" onClick={handleClose} class="btn btn-light">
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
      {
        open && <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="error">
            Il ya un probléme au niveau de serveur
          </Alert>
        </Snackbar>
      }

    </>
  );
}
